import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {ProcessLogUserMappingConfiguration} from "./process-log-user-mapping-configuration";

@JsonObject()
export class ProcessLogConfiguration {

    /**
     * User Mappings. Used to display a different name for users in Log
     */
    @JsonProperty()
    declare userMappings: ProcessLogUserMappingConfiguration[];

    constructor() {}

}
